module.exports = __webpack_public_path__ + "img/stock2.f20bcb65.png";